import { useMutation } from '@tanstack/react-query';

import { Agents } from '@air/api';
import { callAirApi } from '@air/utils-api';

export type UsePrivateWorkspaceAgentSessionSendMessageMutationParams = NonNullable<
  Parameters<typeof Agents.Sessions.Messages.send>[0]
>;

export const usePrivateWorkspaceAgentSessionSendMessageMutation = () =>
  useMutation({
    mutationFn: async (params: UsePrivateWorkspaceAgentSessionSendMessageMutationParams) =>
      callAirApi(() => Agents.Sessions.Messages.send(params)),
  });
